import { jsx as _jsx } from "react/jsx-runtime";
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
const TotalWrapper = styled((props) => _jsx(Stack, Object.assign({}, props)))(({ theme }) => ({
    marginLeft: 'auto',
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.grey[300],
    marginBottom: theme.spacing(2),
}));
export default TotalWrapper;
